import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const ImageSetHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetImageSets([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.ImageSet;
  const count = props.imageFilters.imageSets.length;

  return (
    <FilterHeader
      filterType={FilterTabType.ImageSet}
      isSelected={isSelected}
      labelKey='image_set'
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
